module.exports = __webpack_public_path__ + "img/dgjg2333_1.af004533.svg";